module.exports = __webpack_public_path__ + "static/media/mecanica.62e9e668.jpg";